/**
 * Formats an identifier for an analytics parameter, or undefined when there is none.
 *
 * `String(undefined)` yields the literal text "undefined", which lands in GA4 as a real
 * dimension value and quietly pollutes every breakdown of that parameter.
 *
 */
export function toOptionalId(
  value: string | number | undefined | null
): string | undefined {
  return value === undefined || value === null ? undefined : String(value);
}
